import React, { useState } from "react";
import { BsPlusLg } from "react-icons/bs";
import MultiInputTag from "./MultiInputTag";
import MultiInputTagText from "./MultiInputTagText";

const NestedInput = ({ item, text }) => {
  const { label, name, type, multiple, multipleData, required } = item;

  const element = (item, index) => {
    return text ? (
      <MultiInputTagText
        label={label}
        length={index + 1}
        name={name}
        nameDefaultValue={item.defaultValue[0]}
        defaultValue={item.defaultValue[1]}
        type={type}
        required={required}
      />
    ) : (
      <MultiInputTag
        label={label}
        length={index + 1}
        name={name}
        icon={item.defaultValue[0]}
        defaultValue={item.defaultValue[1]}
        type={type}
        required={required}
      />
    );
  };

  const elementNew = () => {
    return text ? (
      <MultiInputTagText
        label={label}
        name={name}
        type={type}
        required={required}
      />
    ) : (
      <MultiInputTag
        label={label}
        name={name}
        type={type}
        required={required}
      />
    );
  };

  const [quantityCount, setCount] = useState(
    multipleData
      ? multipleData
      : [
          {
            label: label,
            type: "text",
            name: "",
            defaultValue: [],
          },
        ]
  );

  const handleAddElement = () => {
    setCount((current) => [
      ...current,
      {
        label: label,
        type: "text",
        name: "",
        defaultValue: [],
      },
    ]);
  };
  return (
    <div className=" flex flex-row gap-4 items-centers w-full fitHeight  ">
      <div className="col-span-2 w-full ">
        {quantityCount
          ? quantityCount.map((item, index) => element(item, index))
          : elementNew()}
      </div>

      {multiple && (
        <div className="flex justify-center items-end">
          <button
            onClick={handleAddElement}
            type="button"
            className="btn btn-circle"
          >
            <BsPlusLg />
          </button>
        </div>
      )}
    </div>
  );
};

export default NestedInput;
